import { render, staticRenderFns } from "./ArchType.vue?vue&type=template&id=0507fd44&scoped=true&"
import script from "./ArchType.vue?vue&type=script&lang=js&"
export * from "./ArchType.vue?vue&type=script&lang=js&"
import style0 from "./ArchType.vue?vue&type=style&index=0&id=0507fd44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0507fd44",
  null
  
)

export default component.exports